import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

/* Promociones vigentes del negocio (público, sin token).
   → { data: [{ id, title, image_url, url, expires_at, is_active }] } */
export const getPromotions = () => {
  return api.get(`/businesses/${BUSINESS_ID}/promotions`);
};
